<template>
<div id="appmenu" v-cloak>

    <NavbarUte>
    </NavbarUte>

    <div :style="this.styleappend + 'padding-bottom:30px;padding-top:15px;'" v-cloak>
        <router-view>
        </router-view>
    </div>

    <b-container fluid>
        <b-row class="my-3">
            <b-col sm="12" class="text-center">                
                <a style="color:black;" @click.stop="showPP()" href="#">Privacy Policy</a> - Questa pagina non utilizza Cookie
            </b-col>    
        </b-row>
    </b-container>

</div>
</template>

<script>

import NavbarUte from '@/components/utenti/NavbarUte'

export default {
    name: 'appmenu',
    components: {
        NavbarUte: NavbarUte
    },
    data: function () {
        return {
            urlprivacypolicy: localStorage.getItem('urlprivacypolicycral') || '',
            coloreutenti: localStorage.getItem('coloreutenticral') || '',           
            styleappend: '', 
        };
    },
    methods: {        
        showPP() {
            
            window.open(this.urlprivacypolicy, '_blank');

        },
    },
    created: function () {

        //console.log("colore utenti: " + this.coloreutenti)

        if((this.coloreutenti || "") != ""){
            this.styleappend = "background: " + this.coloreutenti + ";";
        }

    }
}
</script>
